import { pick } from 'lodash';
import IPostMessage from '../../IPostMessage';
import IPeerRecovery, { IPeerRecoveryConfiguration, validatePeerRecoveryConfiguration } from './IPeerRecovery';

/** @todo */
export default class PeerRecovery implements IPeerRecovery {
	/** @internal */
	constructor(
		private messagePrefix: string,
		private postMessage: IPostMessage<IPeerRecoveryConfiguration>,
	) {}

	/** @internal */
	public async get(): Promise<IPeerRecoveryConfiguration> {
		const settings = await this.postMessage({ type: this.getMessage('get_peer_recovery') });
		if (!settings.enabled) {
			return pick(settings, ['enabled', 'autoEnableTimeoutMs']);
		}
		return pick(settings, ['enabled', 'urlLauncherAddress']);
	}

	/** @internal */
	public async set(configuration: IPeerRecoveryConfiguration): Promise<void> {
		validatePeerRecoveryConfiguration(configuration);
		await this.postMessage({ type: this.getMessage('set_peer_recovery'), ...configuration });
	}

	private getMessage(name: string) {
		return this.messagePrefix + '.' + name;
	}
}
